// src/clerkConfig.ts
import { ReactNode } from "react";
import { ClerkProvider } from '@clerk/clerk-react'

// Import your publishable key
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key")
}

const ClerkProviderWithConfig = ({ children }: { children: ReactNode }) => {
  return (
    <ClerkProvider 
      publishableKey={PUBLISHABLE_KEY} 
      afterSignOutUrl="/login"
    >
      {children}
    </ClerkProvider>
  );
};

export default ClerkProviderWithConfig;
